import {
  Admin,
  Resource,
  CustomRoutes,
  localStorageStore,
  StoreContextProvider,
} from 'react-admin'
import { Route } from 'react-router-dom'
import AdminInvitation from './pages/AdminInvitation'

import { Dashboard } from './Dashboard'
import { Login } from './Login'

import { UserList, UserShow, UserInvite } from './resources/users'
import {
  ServiceConfigList,
  ServiceConfigShow,
  ServiceConfigEdit,
} from './resources/serviceConfigs'

// https://mui.com/material-ui/material-icons/?theme=Outlined&query=report
import UserIcon from '@mui/icons-material/Group'
import ServiceConfigIcon from '@mui/icons-material/Tune'

import { authProvider, buildResourcePermissions } from './authProvider'
import { dataProvider } from './dataProvider'

import MyLayout from './layout/Layout'
import { ProfileEdit } from './pages/profile'
import { customDarkTheme, customLightTheme, logInBackgroundImage } from './theme/myCustomTheme'

const resources = [
  <Resource
    name="users"
    list={UserList}
    show={UserShow}
    create={UserInvite}
    recordRepresentation="email"
    icon={UserIcon}
    options={{ label: 'Users' }}
  />,
  <Resource
    name="serviceConfigs"
    list={ServiceConfigList}
    edit={ServiceConfigEdit}
    show={ServiceConfigShow}
    recordRepresentation="intervalInMinutes"
    icon={ServiceConfigIcon}
    options={{ label: 'ServiceConfigs' }}
  />,
]

const filterResources = () => {
  const allowedResources = buildResourcePermissions()
  return resources.filter((r) => allowedResources.includes(r.props.name))
}

const store = localStorageStore(undefined, 'timely-cheers-admin')

const App = () => (
  <Admin
    loginPage={
      <Login
        style={{
          backgroundImage: logInBackgroundImage,
        }}
      />
    }
    dataProvider={dataProvider}
    authProvider={authProvider}
    store={store}
    dashboard={Dashboard}
    layout={MyLayout}
    theme={customLightTheme}
    darkTheme={customDarkTheme}
    defaultTheme="light"
  >
    <CustomRoutes>
      <Route key="my-profile" path="/my-profile" element={<ProfileEdit />} />
    </CustomRoutes>
    {filterResources}

    <CustomRoutes noLayout disableAuthentication>
      <Route key="admin-invitation" path="/admin-invitation" element={<AdminInvitation />} />
    </CustomRoutes>
  </Admin>
)

const AppWrapper = () => (
  <StoreContextProvider value={store}>
    <App />
  </StoreContextProvider>
)

export default AppWrapper
